{
    "COMPONENTS": {
        "BUSINESS_UNIT_ICON": {
            "NO_UNIT": "No business unit"
        },
        "DATE_TIME_CELL": {
            "NO_DATE": "No date"
        },
        "DOCUMENT_TYPE_ICON": {
            "NO_TYPE": "No document type"
        },
        "LOGOUT": "Sign Out",
        "LUV_CLAIM": "Product Information Library",
        "USER_INFO": {
            "GREETING": "Welcome, {userName}",
            "MENU": {
                "OUTBOX": "Outbox",
                "CUSTOMER_SEARCH": "Customer search"
            }
        },
        "CUSTOMERS_SELECT": {
            "LABEL": "Customers",
            "PLACEHOLDER": "Please select customers"
        },
        "QUALITY_STATEMENT_TEMPLATE_SELECT": {
            "LABEL": "PDF Template",
            "PLACEHOLDER": "Please select pdf template"
        },
        "MAIL_SENDERS_SELECT": {
            "LABEL": "Sender",
            "PLACEHOLDER": "Select sender",
            "NO_SENDERS": "No senders available"
        },
        "LANGUAGE_ITEMS_SELECT": {
            "LABEL": "Language",
            "PLACEHOLDER": "Select language"
        },
        "COUNTRY_NAMES_SELECT": {},
        "CONTAMINANTS_SELECT": {
            "LABEL": "Contaminants",
            "PLACEHOLDER": "Please select contaminants",
            "NO_OPTIONS": "No contaminants available"
        },
        "NUTRITION_STATEMENTS_SELECT": {
            "LABEL": "Statements",
            "PLACEHOLDER": "Please select Statements",
            "NO_OPTIONS": "No Statements available"
        },
        "STATEMENT_OWNER": {
            "MANAGED_BY": "Maintained by {owner}",
            "LABEL_SUFFIX": "{label} · {owner}"
        },
        "NUTRITION_STATEMENT_CHIPS": {
            "TITLE": "Statements",
            "INFO_TOOLTIP": "Selected statements carry over when you start to create a Lehvoss Statement."
        },
        "CONTAMINANT_CHIPS": {
            "TITLE": "Contaminants",
            "INFO_TOOLTIP": "Selected contaminants carry over when you start to create a Lehvoss Statement."
        },
        "STEP_NAVIGATION": {
            "ITEMS": {}
        },
        "SELECT_ALL_BUTTON": {
            "LABEL": {
                "SELECT_ALL": "Select all",
                "DESELECT_ALL": "Remove all"
            }
        },
        "MAIN_NAVIGATION": {
            "ITEMS": {}
        },
        "CREATE_QUALITY_STATEMENT_BUTTON": {
            "LABEL": "Create Lehvoss Statement",
            "HELPER_TEXT": "Creates a Lehvoss Statement with {count} selected element | Creates a Lehvoss Statement with {count} selected elements"
        },
        "QUALITY_STATEMENT_DOCUMENTS_SELECT": {},
        "MAIL_RECIPIENTS_INPUT": {
            "LABEL": "Recipients",
            "PLACEHOLDER": "Please provide email address(es)",
            "MESSAGE": "Example: \"customer{'@'}customer-url.de\""
        },
        "PRODUCT_INFO": {
            "PRODUCT_NUMBER": "Product no.: {productNumber}",
            "PRODUCT_CHANGE": "change product"
        },
        "MAIL_LOG_ITEMS": {
            "TABLE_HEADER": {
                "DATE": "Date",
                "CUSTOMER": "Customer",
                "SENDER": "Sender",
                "FILES": "Files",
                "PRODUCTS": "Products",
                "STATUS": "Status",
                "ACTIONS": "Actions"
            },
            "DOCUMENT_TABLE_HEADER": {
                "FILE_NAME": "File name",
                "DOCUMENT_TYPE": "Type",
                "PRODUCTS": "Products",
                "ACTIONS": "Actions"
            },
            "TABLE_ROW": {
                "VIEW_DOCUMENT": "View Document",
                "DOWNLOAD_DOCUMENT": "Download Document",
                "PREVIEW_ERROR": "An error occurred while loading the preview. Please try again.",
                "DOWNLOAD_ERROR": "An error occurred while downloading the document. Please try again.",
                "REGENERATE_QUALITY_STATEMENT_DOCUMENT": "Resend",
                "REGENERATE_QUALITY_STATEMENT_ERROR": "An error occurred while preparing the resend. Please try again.",
                "FILE_COUNT": "{count} Files | {count} File | {count} Files",
                "PRODUCT_COUNT": "{count} Products | {count} Product | {count} Products",
                "MORE_PRODUCTS": "+{count} more",
                "NO_PRODUCT": "No Product",
                "NO_SENDER": "Unknown",
                "SHOW_DOCUMENTS": "Show documents",
                "HIDE_DOCUMENTS": "Hide documents",
                "DOCUMENTS_REGION": "Documents of mail \"{subject}\" to {customer} from {date}"
            },
            "MAIL_CONTENT": {
                "BUTTON_LABEL": "View mail content",
                "TITLE": "Mail content",
                "RECIPIENT": "Recipient",
                "SUBJECT": "Subject",
                "TEXT": "Text",
                "NOT_AVAILABLE": "Not available"
            },
            "RESEND_MAIL": {
                "BUTTON_LABEL": "Resend mail",
                "REPLACE_CART_TITLE": "Replace open cart?",
                "REPLACE_CART_TEXT": "You have an open cart. Resending this mail deletes it and replaces it with a new cart containing the documents of this mail. This cannot be undone.",
                "REPLACE_CART_CONFIRM": "Replace cart",
                "REPLACE_CART_CANCEL": "Cancel",
                "NOTICE_TITLE": "Mail could not be resent",
                "NOTICE_CLOSE": "Close",
                "NOT_RESENDABLE": "This mail was not sent via the cart and cannot be resent.",
                "ERROR": "An error occurred while resending the mail. Your open cart was not changed. Please try again."
            },
            "SEND_STATUS": {
                "SENT": "Sent",
                "NOT_SENT": "Not sent"
            }
        },
        "CHECKOUT": {
            "ADD_TO_CART_BUTTON": {
                "LABEL_ADD": "Add to Cart",
                "LABEL_REMOVE": "Remove from Cart",
                "LABEL_ERROR": "An error occurred. Please try again."
            },
            "CART_MENU_BUTTON": {
                "DOCUMENTS_COUNT": "{count} Documents | {count} Document | {count} Documents"
            },
            "CART_FLYOUT": {
                "EMPTY_CART": "Your cart is empty",
                "GO_TO_CART_LABEL": "Begin checkout process"
            },
            "GO_BACK_BUTTON": "Go back"
        },
        "APP_UPDATE_BANNER": {
            "MESSAGE": "A new version of AutoQ is available.",
            "BUTTON": "Update now"
        }
    },
    "VIEWS": {
        "MODULAR_QSW": {
            "NAVIGATION": {
                "LABEL_NEXT": "Next",
                "LABEL_PREVIOUS": "Back",
                "LABEL_FINISH": "Finish",
                "LABEL_BACK_TO_PRODUCT": "Back to product",
                "ERROR_MESSAGE": "Something went wrong. Please try again.",
                "ERROR_RETRY_LABEL": "Try again"
            },
            "PAGE_TITLES": {
                "SELECT_DATA": "Select Data",
                "DOCUMENT_PREVIEW": "Document Preview",
                "NUTRITION_STATEMENTS_EDITOR": "Statement Editor"
            },
            "ELEMENT_TITLES": {
                "DOCUMENT_SETTINGS": "Document Settings",
                "DATA_SETTINGS": "Data Settings",
                "CREATE_NEW_NUTRITION_STATEMENT": "Create new statement",
                "CUSTOMIZATION": "Customization",
                "CUSTOM_PCF_VALUE": "PCF Value",
                "RENDER_PCF_VALUE": "Integrate PCF Value"
            },
            "ELEMENT_LABELS": {
                "ANNOTATIONS_ELEMENT": "Annotations",
                "NUTRITION_STATEMENTS": "Statements",
                "CONTAMINANTS": "Contaminants",
                "RECIPIENTS": "Mail Recipients",
                "CUSTOMER": "Customer",
                "LANGUAGE": "Language",
                "CUSTOM_PCF_VALUE": "PCF Value",
                "DOCUMENT_TEMPLATE": "PDF Template",
                "RENDER_PCF_VALUE": "Integrate PCF Value"
            },
            "REGENERATE_QUALITY_STATEMENT_CHANGES": {
                "LABEL": "Changes since original send",
                "TOGGLE_LABEL": "Toggle changes",
                "TABLE_HEADER": {
                    "WHAT_CHANGED": "What changed",
                    "LAST_UPDATED": "Last updated",
                    "FIELD": "Field"
                },
                "GO_TO_FIELD": "Go to field"
            },
            "NUTRITION_STATEMENTS_EDITOR": {
                "LABELS": {
                    "RESET_NUTRITION_STATEMENT": "Reset",
                    "NUTRITION_STATEMENT_NAME": "Statement name",
                    "NUTRITION_STATEMENT_TEXT": "Statement text",
                    "SAVE_ERROR": "Your changes could not be saved. Please try again."
                }
            },
            "NEW_NUTRITION_STATEMENT": {
                "LABELS": {
                    "NAME": "Statement name",
                    "TEXT": "Statement description",
                    "DELETE": "Delete statement",
                    "ADD": "Add",
                    "CANCEL": "Cancel"
                },
                "VALIDATION": {
                    "NO_STATEMENTS": "To proceed, you must provide a contaminant, an existing nutrition statement, a new nutrition statement or a valid PCF value"
                }
            },
            "SUB_HEADER": {
                "TITLE": "Create a Lehvoss Statement for"
            }
        },
        "PRODUCT_SEARCH": {
            "HEADER": {
                "TEXT_SEARCH": {
                    "LABEL": "Searching for",
                    "PLACEHOLDER": "Product no. or name",
                    "BUTTON": "Search product"
                }
            },
            "RESULTS": {
                "ITEMS": {
                    "HEADER": {
                        "PRODUCT_NUMBER": "Product no.",
                        "PRODUCT": "Product name",
                        "DESCRIPTION": "Description"
                    }
                },
                "NO_RESULTS": {
                    "HEADLINE": "No products found",
                    "TEXT": "Your search did not match any products. Please try different search terms.",
                    "RESET": "Reset search"
                }
            },
            "FILTER": {
                "RESET": {
                    "LABEL": "Reset filter"
                },
                "DROPDOWN_FILTER": {
                    "LABEL": "Please select"
                }
            },
            "META": {}
        },
        "PRODUCT_OVERVIEW": {
            "TABLE": {
                "HEADERS": {},
                "ACTIONS": {
                    "SELECT_PRODUCT": "Select product"
                }
            },
            "NO_RESULTS": {},
            "SEARCH_PROMPT": {}
        },
        "ERROR_PAGE": {
            "TITLE": "Ooops! Something Went Wrong",
            "TEXT": "We apologise, but it looks like there was an error. Our team has been notified and is working to resolve the issue. In the meantime, you can:",
            "LINK": {
                "GO_HOME": "Go back to the homepage",
                "GO_BACK": "Go back and try again",
                "CONTACT": "Contact our support team"
            }
        },
        "ERROR_NOT_FOUND": {
            "TITLE": "Not Found",
            "TEXT": "The page you are looking for could not be found. It may have been moved, deleted, or the URL might be incorrect or you do not have access.",
            "LINK": {
                "GO_HOME": "Go back to the homepage",
                "SEARCH": "Look for another product"
            }
        },
        "CUSTOMER_CREATE": {
            "FORM": {
                "LABELS": {
                    "CUSTOMER_NUMBER": "Customer Number",
                    "CUSTOMER_NAME": "Customer Name",
                    "SUBMIT": "Add new customer"
                }
            }
        },
        "PRODUCT_DETAIL": {
            "PRODUCT_INFO": {
                "LABEL_PRODUCT_NUMBER": "Product no.",
                "LABEL_PRODUCT_AVAILABILITY": "Availability"
            },
            "PRODUCT_DOCUMENTS": {
                "LABELS": {
                    "SUPPLIER": "Supplier",
                    "NO_SUPPLIER": "No Supplier",
                    "LANGUAGE": "Language",
                    "OPEN": "View Document",
                    "DOWNLOAD": "Download Document",
                    "DOCUMENT_TYPE": "Document Type",
                    "FILENAME": "Filename",
                    "CREATION_DATE": "Creation Date",
                    "TOGGLE_DOCUMENTS": "Toggle Documents Visibility",
                    "TOGGLE_LEHVOSS_STATEMENTS": "Toggle Lehvoss Statement Elements Visibility",
                    "LOAD_ERROR": "An error occurred while loading the documents. Please try again.",
                    "PREVIEW_ERROR": "An error occurred while loading the preview. Please try again.",
                    "DOWNLOAD_ERROR": "An error occurred while downloading the document. Please try again.",
                    "WATERMARK_LABEL": "PREVIEW",
                    "PCF": "PCF",
                    "NUTRITION_STATEMENTS": "Statements",
                    "CONTAMINANTS": "Contaminants"
                },
                "CATEGORIES": {
                    "SALES_DOCUMENTS": "Sales Documents",
                    "CONTROLLED_SUPPLIER_DOCUMENTS": "Controlled Supplier Documents",
                    "CONTROLLED_LEHVOSS_STATEMENTS": "Controlled Lehvoss Statements",
                    "OTHER": "Other"
                }
            },
            "HISTORY": {
                "LABEL": "History"
            }
        },
        "OUTBOX": {
            "TITLE": "Outbox",
            "PLACEHOLDER_TEXT": "Your sent documents and statements will appear here soon.",
            "NO_RESULTS": {
                "HEADLINE": "No activity found",
                "FILTERED_TEXT": "No activity matches your filters."
            },
            "FILTER": {
                "DATE_RANGE": {
                    "LABEL": "Date range"
                },
                "RESET": "Reset filters"
            },
            "TABLE": {
                "LABEL": "History",
                "TOGGLE_LABEL": "Toggle History"
            },
            "STATISTICS": {
                "USER": "User",
                "LAST_SEND_DATE": "Last sent",
                "CUSTOMER_COUNT": "Customers contacted",
                "SENT_COUNT": "Sent successfully",
                "NOT_SENT_COUNT": "Failed to send",
                "DOCUMENT_CATEGORIES": "Documents by category",
                "EMPTY_VALUE": "–"
            }
        },
        "CUSTOMER_SEARCH": {
            "TITLE": "Customer search",
            "NO_RESULTS": {
                "HEADLINE": "No customers found",
                "TEXT": "There are no customers yet.",
                "FILTERED_TEXT": "No customer matches your search."
            },
            "FILTER": {
                "FULLTEXT": {
                    "LABEL": "Search",
                    "PLACEHOLDER": "Customer name or number"
                },
                "HAS_ACTIVITY": {
                    "LABEL": "Customer has activity"
                },
                "RESET": "Reset filters"
            },
            "TABLE": {
                "LABEL": "Customers",
                "TOGGLE_LABEL": "Toggle customers",
                "NO_ACTIVITY": "No activity",
                "HEADER": {
                    "CUSTOMER_NAME": "Customer name",
                    "CUSTOMER_NUMBER": "Customer number",
                    "LAST_ACTIVITY": "Last activity",
                    "ACTIONS": "Actions"
                },
                "ACTIONS": {
                    "SELECT_CUSTOMER": "Select customer",
                    "SELECT_CUSTOMER_NAMED": "Select customer {name}"
                }
            }
        },
        "CUSTOMER_DETAIL": {
            "ADDRESS": "Address",
            "EMAIL": "Email",
            "LAST_ACTIVITY": "Last activity",
            "NO_ACTIVITY": "No activity",
            "ACTIVITY_COUNT": "Number of activities",
            "NO_ACTIVITY_COUNT": "Not available yet",
            "LOAD_ERROR": {
                "HEADLINE": "Customer could not be loaded",
                "TEXT": "The customer data could not be loaded. Please try again.",
                "RETRY": "Try again"
            },
            "HISTORY": {
                "LABEL": "History",
                "TOGGLE_LABEL": "Toggle History",
                "FILTER": {
                    "PRODUCT_NUMBER": {
                        "LABEL": "Product number"
                    },
                    "PRODUCT_NAME": {
                        "LABEL": "Product name"
                    },
                    "CONTENT": {
                        "LABEL": "Type",
                        "PLACEHOLDER": "Select type"
                    },
                    "EMAIL": {
                        "LABEL": "Email address"
                    },
                    "DATE_RANGE": {
                        "LABEL": "Date range"
                    },
                    "RESET": "Reset filters"
                },
                "LOAD_ERROR": {
                    "TEXT": "The activity history could not be loaded.",
                    "RETRY": "Try again"
                },
                "EMPTY": {
                    "TEXT": "No documents have been sent to this customer yet."
                },
                "NO_RESULTS": {
                    "FILTERED_TEXT": "No activity matches your filters."
                },
                "DOCUMENT_TYPE": {
                    "NO_TYPE": "No document type"
                }
            }
        },
        "SEND_DOCUMENT_WIZARD": {
            "PREVIEW": {
                "NO_RESULTS": {},
                "NO_DOCUMENT_IDS": {},
                "FOOTER": {}
            },
            "SEND": {},
            "SUCCESS": {},
            "FAILED": {},
            "ROUTE_SWITCH": {}
        },
        "CHECKOUT": {
            "SUB_HEADER": {
                "HEADLINE": "Documents cart",
                "DOCUMENTS_COUNT": "{count} documents in cart | {count} document is ready to send | {count} documents are ready to send",
                "BACK_BUTTON_LABEL": "Leave cart"
            },
            "CART_OVERVIEW": {
                "REMOVED_DOCUMENTS": {
                    "TITLE": "Document no longer available and not added to the cart | {count} document is no longer available and was not added to the cart | {count} documents are no longer available and were not added to the cart",
                    "UNKNOWN_DOCUMENT": "Unknown document (ID {id})"
                },
                "DOCUMENTS_HEADLINE": "Documents",
                "DOCUMENTS_UPLOAD_HEADLINE": "Upload documents",
                "CUSTOM_DOCUMENTS_HEADLINE": "Uploaded documents",
                "SUBMIT_BUTTON_LABEL": "Submit",
                "ATTACHMENTS_TOO_LARGE_MESSAGE": "The selected documents are too large to be sent in one email ({size} MB of max. {maxSize} MB). Please remove some documents and submit again.",
                "MAIL_SIZE_HINT": "Emails can be at most {maxSize} MB. Currently: {size} of {maxSize} MB.",
                "MAIL_SENDER": {
                    "SUBJECT_LABEL": "Mail Subject",
                    "BODY_LABEL": "Mail Body",
                    "SAVE_BUTTON_LABEL": "Save"
                }
            },
            "CART_META_DATA": {
                "PREDEFINED_DOCUMENTS": {
                    "HEADLINE": "Lehvoss Documents"
                },
                "CUSTOMER_SELECT": {
                    "ADD_CUSTOMER": "Add new customer"
                },
                "FOOT_NOTE": {
                    "REQUIRED": "Required"
                }
            },
            "SUCCESS_PAGE": {
                "HEADLINE": "Documents were sent",
                "SUB_HEADLINE": "You successfully sent your documents"
            },
            "ERROR_PAGE": {
                "HEADLINE": "There was a problem",
                "SUB_HEADLINE": "Please try again later"
            },
            "CART_IS_EMPTY": {
                "HEADLINE": "Your cart is empty",
                "SUB_HEADLINE": "Please add or upload  at least one document to proceed"
            },
            "CREATE_CUSTOMER": {
                "SUB_HEADER": {
                    "BACK_BUTTON": "Go back without saving"
                }
            }
        }
    },
    "validations": {
        "required": "Please fill out!",
        "requiredHtml": "Please fill out!",
        "maxLength": "Please do not enter more than {max} characters",
        "customerExists": "A customer with this customer number already exists",
        "emailFragment": "Please enter a valid email address or part of one"
    },
    "VALIDATION": {
        "ERROR": {
            "ARRAY_MIN": "{label} must contain at least {count} item | {label} must contain at least {count} items",
            "OBJECT_UNKNOWN": "{label} is not allowed here",
            "OBJECT_BASE": "{label} must be selected",
            "ANY_REQUIRED": "{label} is a required field",
            "ANY_ONLY": "{label} must be selected",
            "NUMBER_BASE": "{label} must be a number",
            "NUMBER_MIN": "{label} must be at least {count}",
            "ARRAY_INCLUDESREQUIREDUNKNOWNS": "{label} does not contain the required format",
            "STRING_EMPTY": "{label} must not be empty",
            "ANY_INVALID": "{label} contains an invalid value"
        }
    }
}
